import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE, // "production" | "development"
  // Hanya aktif kalau DSN tersedia
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Capture 10% request traces di production (gratis tier friendly)
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
  // Replay hanya saat error
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event, hint) {
    const msg = (hint?.originalException as Error)?.message ?? "";
    // Supabase Realtime/Phoenix WebSocket fallback — bukan error nyata, ditangani di sumber
    if (msg.includes("WebSocket not available") || msg.includes("construct 'WebSocket'")) {
      return null;
    }
    // Error internal Android in-app browser (WhatsApp/Instagram/dll) — Java bridge GC'd
    // Terjadi saat pengunjung buka halaman dari dalam aplikasi chat, bukan dari kode kita
    if (msg.includes("Java object is gone") || msg.includes("iabjs://") || msg.includes("enableDidUserTypeOnKeyboard")) {
      return null;
    }
    return event;
  },
});
